export const PASSWORD_COPY = {
  placeholder: 'Enter password',
  label: 'Password',
  ariaLabels: {
    showPassword: 'Show password',
    hidePassword: 'Hide password',
  },
  tooltips: {
    showPassword: 'Click to show password',
    hidePassword: 'Click to hide password',
  },
} as const;
